import { createDb, type DatabaseDriver } from '@w/db'
import type { Tel } from '@w/tel'
import { workspaceTables, createWorkspaceDb } from './workspace-tables'
export function createClientDb(driver: DatabaseDriver, tel?: Tel) {
  const db = createWorkspaceDb(driver)
  return tel ? db.withTel(tel) : db
}
export function createClientDbSchema(options?: { driver?: DatabaseDriver }) {
  return createDb(workspaceTables, { driver: options?.driver })
}
export type ClientDb = ReturnType<typeof createClientDb>
